import React from 'react';
import './Hero.css';
import beeElectrician from '../assets/bee-electrician.png';
import beePlumber from '../assets/bee-plumber.png';
import beeCarpenter from '../assets/bee-carpenter.png';
import beePainter from '../assets/bee-painter.png';
import honeyBee from '../assets/scout-bee.png';

const Hero = () => {
    const handleBookService = () => {
        const servicesSection = document.getElementById('services');
        if (servicesSection) {
            servicesSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleOpenHoney = () => {
        window.dispatchEvent(new CustomEvent('skillhive:openChat'));
    };

    return (
        <section className="hero" id="home">
            <div className="container">
                <div className="hero-content">
                    <div className="hero-text">
                        <h1 className="hero-title">
                            Your Trusted Partner for
                            <span className="gradient-text"> Home Services</span>
                        </h1>
                        <p className="hero-description">
                            Connect with verified professionals for all your home needs.
                            From plumbing to electrical work, we've got you covered.
                        </p>
                        <div className="hero-actions">
                            <button className="btn btn-primary btn-lg" onClick={handleBookService}>Book a Service</button>
                            <button className="btn btn-secondary btn-lg" onClick={handleOpenHoney}>Ask Honey AI <img src={honeyBee} alt="Honey" style={{ width: '28px', height: 'auto', verticalAlign: 'middle', marginLeft: '4px' }} /></button>
                        </div>
                        <div className="hero-stats">
                            <div className="stat">
                                <h3>50K+</h3>
                                <p>Happy Customers</p>
                            </div>
                            <div className="stat">
                                <h3>10K+</h3>
                                <p>Verified Professionals</p>
                            </div>
                            <div className="stat">
                                <h3>4.8★</h3>
                                <p>Average Rating</p>
                            </div>
                        </div>
                    </div>
                    <div className="hero-image">
                        <svg className="hero-honeycomb" viewBox="0 0 300 300">
                            {/* Create hexagonal honeycomb shape */}
                            {(() => {
                                const createHexagon = (cx, cy, radius) => {
                                    const points = [];
                                    for (let i = 0; i < 6; i++) {
                                        const angle = (Math.PI / 3) * i;
                                        const x = cx + radius * Math.cos(angle);
                                        const y = cy + radius * Math.sin(angle);
                                        points.push(`${x},${y}`);
                                    }
                                    return points.join(' ');
                                };

                                const hexRadius = 25;
                                const hexWidth = hexRadius * 2 * Math.sin(Math.PI / 3);

                                // Create hexagonal pattern - center and rings
                                const hexagons = [
                                    // Center
                                    { x: 150, y: 150 },

                                    // Ring 1 (6 hexagons)
                                    { x: 150, y: 150 - hexWidth },
                                    { x: 150 + hexRadius * 1.5, y: 150 - hexWidth / 2 },
                                    { x: 150 + hexRadius * 1.5, y: 150 + hexWidth / 2 },
                                    { x: 150, y: 150 + hexWidth },
                                    { x: 150 - hexRadius * 1.5, y: 150 + hexWidth / 2 },
                                    { x: 150 - hexRadius * 1.5, y: 150 - hexWidth / 2 },

                                    // Ring 2 (12 hexagons)
                                    { x: 150, y: 150 - hexWidth * 2 },
                                    { x: 150 + hexRadius * 1.5, y: 150 - hexWidth * 1.5 },
                                    { x: 150 + hexRadius * 3, y: 150 - hexWidth },
                                    { x: 150 + hexRadius * 3, y: 150 },
                                    { x: 150 + hexRadius * 3, y: 150 + hexWidth },
                                    { x: 150 + hexRadius * 1.5, y: 150 + hexWidth * 1.5 },
                                    { x: 150, y: 150 + hexWidth * 2 },
                                    { x: 150 - hexRadius * 1.5, y: 150 + hexWidth * 1.5 },
                                    { x: 150 - hexRadius * 3, y: 150 + hexWidth },
                                    { x: 150 - hexRadius * 3, y: 150 },
                                    { x: 150 - hexRadius * 3, y: 150 - hexWidth },
                                    { x: 150 - hexRadius * 1.5, y: 150 - hexWidth * 1.5 },
                                ];

                                return hexagons.map((hex, i) => (
                                    <polygon
                                        key={i}
                                        points={createHexagon(hex.x, hex.y, hexRadius)}
                                        fill="none"
                                        stroke="#FFD700"
                                        strokeWidth="3"
                                        strokeLinejoin="round"
                                        className={`hero-hex hex-${i}`}
                                    />
                                ));
                            })()}

                            {/* Cartoon Bees as Images */}
                            <g className="hero-bees">
                                {/* Bee 1 - Electrician */}
                                <image
                                    href={beeElectrician}
                                    x="180"
                                    y="10"
                                    width="80"
                                    height="80"
                                    className="hero-bee bee-1"
                                    style={{ transformOrigin: 'center', transformBox: 'fill-box' }}
                                />

                                {/* Bee 2 - Plumber */}
                                <image
                                    href={beePlumber}
                                    x="220"
                                    y="125"
                                    width="80"
                                    height="80"
                                    className="hero-bee bee-2"
                                    style={{ transformOrigin: 'center', transformBox: 'fill-box' }}
                                />

                                {/* Bee 3 - Carpenter */}
                                <image
                                    href={beeCarpenter}
                                    x="0"
                                    y="210"
                                    width="80"
                                    height="80"
                                    className="hero-bee bee-3"
                                    style={{ transformOrigin: 'center', transformBox: 'fill-box' }}
                                />

                                {/* Bee 4 - Painter */}
                                <image
                                    href={beePainter}
                                    x="-30"
                                    y="120"
                                    width="80"
                                    height="80"
                                    className="hero-bee bee-4"
                                    style={{ transformOrigin: 'center', transformBox: 'fill-box' }}
                                />
                            </g>
                        </svg>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
